<template>
  <div class="product-count-chart-slot">
    <canvas id="myChart" class="frame"></canvas>
  </div>
</template>

<script>
import layoutMixin from "@/mixins/layoutMixin";
import { BFormInput, BFormGroup, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Chart from "chart.js/auto";
import axios from "@axios";
import { computed, watch, onBeforeUnmount, onMounted } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";

export default {
  mixins: [layoutMixin],
  components: {
    BFormInput,
    BButton,
    BFormGroup,
  },
  props: {
    data: {
      type: Object,
    },
  },
  directives: {
    Ripple,
  },
  async setup() {
    let chartInstance = null;

    const { skin } = useAppConfig();
    const isDark = computed(() => skin.value === "dark");

    setInterval(createChart, 5000);

    const createChart = async () => {
      let products = await axios.get("/v1/count_product/stream");
      const ctx = document.getElementById("myChart");

      chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels: Object.keys(products.data),
          datasets: [
            {
              label: "# of Products",
              backgroundColor: "#57D3DD",
              data: Object.values(products.data),
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: isDark.value ? "#fff" : "#000",
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                color: isDark.value ? "#fff" : "#000",
                stepSize: 1,
              },
              grid: {
                color: "#EDF7F7",
              },
            },
          },
          plugins: {
            legend: {
              position: "top",
              labels: {
                font: {
                  size: 12,
                  weight: 500,
                },
                color: isDark.value ? "#fff" : "#000",
                boxWidth: 8,
                boxHeight: 8,
                usePointStyle: true,
                pointStyle: "circle",
              },
            },
          },
        },
      });
    };

    const destroyChart = () => {
      if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
      }
    };

    watch(isDark, () => {
      destroyChart();
      createChart();
    });

    onMounted(() => {
      createChart();
    });

    onBeforeUnmount(() => {
      destroyChart();
    });

    return {};
  },
};
</script>

<style lang="scss" scoped>
.product-count-chart-slot {
  width: 100%;
  height: 100%;
}

.frame {
  width: 100% !important;
  height: 100% !important;
  border: none;
  overflow: hidden;
}
</style>
